import { Component, Input, OnInit } from '@angular/core';
import {
  ITitleIcon,
  ITitleSubtitleFontStyle,
  SharedConstants,
  SharedCssClassNames,
  TextType,
  titleFontType,
  titleSubTitleConfig,
  TitleSubTitlePadding
} from '@app/eds';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type AlignmentType = 'left' | 'right' | 'centerColumn';

@Component({
  selector: 'app-title-subtitle',
  templateUrl: './title-subtitle.component.html',
  styleUrls: ['./title-subtitle.component.scss']
})
export class TitleSubtitleComponent implements OnInit {
  // the alignment of the texts
  @Input() alignment!: AlignmentType;

  // gives us the padding for the subtitle text
  @Input() subtitlePadding: string = TitleSubTitlePadding;

  // the title for te component
  @Input() title!: string;

  // the subtitle for the component
  @Input() subtitle!: string;

  // Secondary subtitle text that can be of different font config
  @Input() secondarySubtitle!: string;

  // the font style for the title
  @Input() titleFontStyle: TextType = 'body1';

  //this configuration file for the title
  @Input() configFontStyle!: titleFontType;

  // the font style for the sub-title
  @Input() subtitleFontStyle: TextType = 'headline1';

  // Font style to be provided to the secondary subtitle font
  @Input() secondarySubtitleFontStyle!: TextType;

  // custom Style for inputting to app-text
  @Input() public subTitleStyle!: { [key: string]: string };

  // If true then icon will be shown after title
  @Input() showTitleRightIcon = false;

  // Right Icon Name, using material icon
  @Input() rightTitleIconName: string = SharedConstants.EMPTY_STRING;

  // Common Class Names for Right Icons in title
  @Input() rightTitleIconClassNames: string[] = [];

  // Right icon size
  @Input() rightTitleIconSize: string = SharedConstants.EMPTY_STRING;

  // To specify what text should be shown in the subtitle tooltip.
  @Input() subtitleToolTipText!: string;

  // Class name for tooltip component
  @Input() tooltipCustomClass: string = SharedConstants.EMPTY_STRING;

  // Class name for title-subtitle component
  @Input() titleSubtitleClassName: string = SharedCssClassNames.TITLE_SUBTITLE_CONTENT;

  // Maximum width of the subtitle text,
  // after which the ellipsis is going to be displayed.
  @Input() maxSubtitleWidth!: string;

  // If true then require symbol will be displayed on title.
  @Input() showTitleRequiredStar = false;

  // If true then icon will be shown after subtitle
  @Input() showSubtitleRightIcon: boolean = false;

  // Right Icon Name, using material icon
  @Input() rightSubtitleIconName: string = '';

  // Right Icon color
  @Input() rightSubtitleIconColor: string = '';

  // Right icon size
  @Input() rightSubtitleIconSize: string = '';

  // If title have more than one icon, config other icon here
  @Input() otherTitleIcons: ITitleIcon[] = [];

  // Custom styles to the subtitle text.
  subtitleStyles = {};

  ngOnInit(): void {
    this.setFontStyle();
    this.setSubtitleStyles();
  }

  /**
   * Sets the styles for the title and subtitle text.
   */
  setFontStyle() {
    const titleValue: ITitleSubtitleFontStyle = titleSubTitleConfig[this.configFontStyle];

    if (titleValue) {
      this.titleFontStyle = titleValue.titleFontStyle;
      this.subtitleFontStyle = titleValue.subtitleFontStyle;
    }
  }

  /**
   * Gets the class name.
   */
  getClass = (): string => {
    switch (this.alignment) {
      case 'left':
        return 'left-aligned';
      case 'right':
        return 'right-aligned';
      case 'centerColumn':
        return 'center-aligned-column';
      default:
        return 'left';
    }
  };

  /**
   * Sets the styles for the subtitle text.
   */
  setSubtitleStyles = () => {
    this.maxSubtitleWidth && (this.subtitleStyles = { maxWidth: this.maxSubtitleWidth });
    this.subtitlePadding &&
      (this.subtitleStyles = {
        ...this.subtitleStyles,
        paddingTop: this.subtitlePadding
      });
  };
}
